import AvgCheckReport from './views/AvgCheckReport.vue'
import routes from './routes'
export const AvgCheckReportModule = {
    views: { AvgCheckReport },
    routes,
}
